interface TokenAmountDisplayProps {
  amount: string;
  onEdit?: () => void;
}

export const TokenAmountDisplay = ({ amount }: TokenAmountDisplayProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="text-2xl font-bold">{amount}</div>
    </div>
  );
};